import React, { createContext, useContext } from "react";

const DateLocaleContext = createContext();

export const useDateLocale = () => useContext(DateLocaleContext);

export const DateLocaleProvider = ({ locale, children }) => (
  <DateLocaleContext.Provider value={locale}>
    {children}
  </DateLocaleContext.Provider>
);
